import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const getModelDataUpdates = async ({ status, days }) => {
    const response = await Axios.post('/ContactGateway/GetDataUpdates', {
        status,
        Days: days,
    });
    return response;
};

const useModelDataUpdates = ({ status, days, enabled = true } = {}) => {
    const queryEnabled = Boolean(status) && enabled;
    return useQuery({
        queryKey: ['modelDataUpdates', status, days ?? null],
        queryFn: () => getModelDataUpdates({ status, days }),
        enabled: queryEnabled,
        cacheTime: 60000,
    });
};

const forceReloadModelDataUpdates = () => {
    queryClient.invalidateQueries({ queryKey: ['modelDataUpdates'] });
};

export { useModelDataUpdates, forceReloadModelDataUpdates };
